import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FooterContainer = styled.footer`
  padding: 2rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  text-align: center;
  border-top: 1px solid ${({ theme }) => theme.color};
  position: relative;
  overflow: hidden;
`;

const FooterText = styled(motion.p)`
  margin: 0;
  font-size: 1rem;
  z-index: 10;
`;

const SocialLinks = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
`;

const SocialLink = styled(motion.a)`
  color: ${({ theme }) => theme.accent};
  font-size: 1.5rem;
  text-decoration: none;
  position: relative;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.color};
  }

  &:before {
    content: '';
    position: absolute;
    width: 0%;
    height: 2px;
    bottom: -5px;
    left: 50%;
    background-color: ${({ theme }) => theme.accent};
    transition: width 0.4s ease, left 0.4s ease;
  }

  &:hover:before {
    width: 100%;
    left: 0;
  }
`;

const FloatingBackground = styled(motion.div)`
  position: absolute;
  width: 150%;
  height: 300px;
  background: ${({ theme }) => theme.background};
  top: -150px;
  left: -25%;
  z-index: 0;
  border-radius: 50%;
  filter: blur(100px);
`;

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <FooterContainer>
            <FloatingBackground
                animate={{
                    x: [0, 50, 0],
                    y: [0, -50, 0],
                }}
                transition={{
                    duration: 10,
                    repeat: Infinity,
                    repeatType: 'mirror',
                }}
            />
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
            >
                <FooterText
                    animate={{
                        scale: [1, 1.05, 1],
                    }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        repeatType: 'mirror',
                    }}
                >
                    © {currentYear} Harsh Dhama. All rights reserved.
                </FooterText>
                <SocialLinks>
                    <SocialLink
                        href="https://github.com/harsh-d-lab"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="GitHub"
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <i className="fab fa-github"></i> GitHub
                    </SocialLink>
                    <SocialLink
                        href="https://www.linkedin.com/in/harsh-dhama-06a5921aa/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <i className="fab fa-linkedin"></i> LinkedIn
                    </SocialLink>
                    <SocialLink
                        href="mailto:dhamaharsh9@gmail.com"
                        aria-label="Email"
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <i className="fas fa-envelope"></i> Email
                    </SocialLink>
                </SocialLinks>
            </motion.div>
        </FooterContainer>
    );
};

export default Footer;
